const TableBody = ({ children }) => {
  return <tbody className="w-full divide-y divide-gray-200 bg-white overflow-y-auto">{children}</tbody>;
};

export default TableBody;
